import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx={12} cy={12} r={8} fill="currentColor" />
    <path d="M13 11l2 2 1.5-1.5L12 7l-4.5 4.5L9 13l2-2v6h2v-6z" fill="#fff" />
  </svg>
);
